import { Link } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const NeedHelp: FC = () => {
  const { t } = useTranslation();

  return (
    <Link
      variant="caption"
      href="https://help.changeengine.com"
      target="_blank"
      rel="noreferrer"
      color="text.sidebar"
      underline="always"
    >
      {t("Need help?")}
    </Link>
  );
};
